import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  module: null,
}

const moduleSlice = createSlice({
  name: 'module',
  initialState,
  reducers: {
    setModule(state, action) {
      state.module = action.payload;
    }
  }
})

export const { setModule } = moduleSlice.actions;
export default moduleSlice.reducer;
